


















import { Component, Vue, Watch } from "vue-property-decorator";
import { startOfMonth, endOfMonth, addMonths, parseISO, format } from "date-fns";

import EspressoAux from "@/components/Espresso/EspressoAux.vue"
import PaginatedSearch from "@/layouts/DashboardLayoutComponents/SoniprevPaginatedSearch.vue";
import CreationCard from "@/layouts/DashboardLayoutComponents/CreationCard.vue";
import FormField from "@/layouts/DashboardLayoutComponents/FormField.vue";

import accountReceivableModel from "@/models/accountReceivable.model";

@Component({
	components: {
		PaginatedSearch,
		CreationCard,
		FormField,
	},
})
export default class AccountsReceivable extends Vue {
	entityModel: any;

	filterSchema: any[] = [
		{ name: "Data início", key: "startDate", kind: "date" },
		{ name: "Data fim", key: "endDate", kind: "date" },
	];
	filterEntity: any = {
		startDate: startOfMonth(new Date()).toISOString(),
		endDate: endOfMonth(new Date()).toISOString(),
	};

	creationFields = [
		{ key: "name", class: "md-size-25" },
		{ key: "expirationDate", class: "md-size-15" },
		{ key: "baseAmount", class: "md-size-15" },
		{ key: "receiptDate", class: "md-size-15" },
		{ key: "receiptAmount", class: "md-size-15" },
		{ key: "interestPenaltyAmount", class: "md-size-15" },
	];

	searchActions = [
		{ name: 'Excluir', icon: 'delete', color: '#FF5C5C', action: this.deleteAccount },
	];

	csvModel = `\uFEFFReceita;Data de vencimento;Valor;Data do recebimento;Valor a receber;Juros/multa
Contrato UPA;29/08/2020;256425,77;;256425,77;0
Contrato Hospital;28/08/2020;450148,26;;450148,26;0`;

	constructor() {
		super();
		this.entityModel = accountReceivableModel;
	}

	get searchFilter() {
		return {
			expirationDate: { $gte: this.filterEntity.startDate, $lte: this.filterEntity.endDate },
		};
	}

	async deleteAccount(account: any) {
		if (!(await EspressoAux.showConfirmationModal('Confirma a exclusão?')).value) {
			return;
		}
		try {
			await accountReceivableModel.delete(account.id);
			this.$toasted.success('Conta excluída');
			(this.$refs.accountsSearch as any).refresh();
		} catch (error) {
			this.$toasted.error(error.friendlyMessage || 'Erro ao excluir. Tente novamente.');
			console.error(error);
		}
	}

	// Accounts copy
	isCopying = false;
	selectedAccounts: any[] = [];
	selectionHandler(accounts: any) {
		this.selectedAccounts = accounts;
	}
	async copyToNextMonth() {
		this.isCopying = true;
		for (const account of this.selectedAccounts) {
			try {
				const nextExpirationDate = addMonths(parseISO(account.expirationDate), 1);
				const accountCopy = { ...account, expirationDate: nextExpirationDate.toISOString(), receiptDate: null, attachmentUrl: null, id: null };
				await accountReceivableModel.create(accountCopy);
				this.$toasted.success(`Conta ${account.name} copiada para o dia ${format(nextExpirationDate, 'dd/MM/yyyy')}`)
			} catch (error) {
				console.error(error);
				this.$toasted.error(`Não foi possível copiar a conta ${account.name}`);
			}
		}
		this.isCopying = false;
		(this.$refs.accountsSearch as any).refresh();
	}
}
